<template>
    <div class="box">
        <div class="contaner-title"><span>项目管理</span> <span>/ 竞标项目</span></div>
        <!-- <div class="hr"></div> -->
        <div>
            <Tabs>
                <div class="add-btn" @click="publishProject">
                    <img src="../../assets/user_icon_white.png"/>
                    <span>发布项目</span>
                </div>
                <TabPane label="全部" class="tab">
                    <ul class="project-list">
                        <li v-for="(item,index) in projectListAll" :key='index'>
                            <img v-if="item.Status==1" src="../../assets/S1.png" alt="">
                            <img v-if="item.Status==2" src="../../assets/S2.png" alt="">
                            <img v-if="item.Status==3 || item.Status==5 || item.Status==6 || item.Status==7" src="../../assets/S3.png" alt="">
                            <img v-if="item.Status==4" src="../../assets/S4.png" alt="">
                            <div>
                                <p><span><span v-if="item.TypeID == 2" class="private-tag">私</span>{{item.Name}}</span><span v-if="item.Status < 4">剩余{{item.DayNum}} 天</span></p>
                                <p>
                                    <span>发布时间 :{{item.AddTime}}</span>
                                    <span v-if="item.Status==0">竞标数 <i>{{item.ProjectMemberNum}}</i> 人</span>
                                    <span v-if="item.Status==1||item.Status==2">结项时间 <i>{{item.EndTime}}</i> </span>
                                </p>
                            </div>
                            <Button type="primary" @click="goDetail(item)"> 管理项目</Button>
                            <Button v-if="item.TypeID == 2" style="margin-right:10px" type="error" @click="goSupplier(item)"> 邀请竞标</Button>
                        </li>
                    </ul>
                    <div v-if="projectListAll.length > 0" style="float:right;padding:30px 0px;">
                        <Page :total="Count" :page-size="PageSize" @on-change="changePage" />
                    </div>
                </TabPane>
                <TabPane label="竞标中"   class="tab">
                    <ul class="project-list">
                        <li v-for="(item,index) in projectListBidding" :key='index'>
                            <img v-if="item.Status==1" src="../../assets/S1.png" alt="">
                            <div>
                                <p><span><span v-if="item.TypeID == 2" class="private-tag">私</span>{{item.Name}}</span><span v-if="item.Status < 4">剩余{{item.DayNum}} 天</span></p>
                                <p>
                                    <span>发布时间 :{{item.AddTime}}</span>
                                    <span v-if="item.Status==0">竞标数 <i>{{item.ProjectMemberNum}}</i> 人</span>
                                    <span v-if="item.Status==1||item.Status==2">结项时间 <i>{{item.EndTime}}</i> </span>
                                </p>
                            </div>
                            <Button type="primary" @click="goDetail(item)"> 管理项目</Button>
                        </li>
                    </ul>
                    <div v-if="projectListBidding.length > 0" style="float:right;padding:30px 0px;">
                        <Page :total="CountBidding" :page-size="PageSize" @on-change="changePageBidding" />
                    </div>
                </TabPane>
                <TabPane label="开发中"   class="tab">
                    <ul class="project-list">
                        <li v-for="(item,index) in projectListDeveloping" :key='index'>
                            <img v-if="item.Status==2" src="../../assets/S2.png" alt="">
                            <div>
                                <p><span><span v-if="item.TypeID == 2" class="private-tag">私</span>{{item.Name}}</span><span v-if="item.Status < 4">剩余{{item.DayNum}} 天</span></p>
                                <p>
                                    <span>发布时间 :{{item.AddTime}}</span>
                                    <span v-if="item.Status==0">竞标数 <i>{{item.ProjectMemberNum}}</i> 人</span>
                                    <span v-if="item.Status==1||item.Status==2">结项时间 <i>{{item.EndTime}}</i> </span>
                                </p>
                            </div>
                            <Button type="primary" @click="goDetail(item)"> 管理项目</Button>
                        </li>
                    </ul>
                    <div v-if="projectListDeveloping.length > 0" style="float:right;padding:30px 0px;">
                        <Page :total="CountDeveloping" :page-size="PageSize" @on-change="changePageDeveloping" />
                    </div>
                </TabPane>
                <TabPane label="已超时"   class="tab">
                    <ul class="project-list">
                        <li v-for="(item,index) in projectListOvertime" :key='index'>
                            <img v-if="item.Status==4" src="../../assets/S4.png" alt="">
                            <div>
                                <p><span>{{item.Name}}</span></p>
                                <p><span>发布时间 :{{item.AddTime}}</span>
                                <span v-if="item.Status==1||item.Status==2">结项时间 <i>{{item.EndTime}}</i> </span>
                                </p>
                            </div>
                            <Button type="primary" @click="goDetail(item)"> 管理项目</Button>
                        </li>
                    </ul>
                    <div v-if="projectListOvertime.length > 0" style="float:right;padding:30px 0px;">
                        <Page :total="CountOvertime" :page-size="PageSize" @on-change="changePageOvertime" />
                    </div>
                </TabPane>
                <TabPane label="已完结"   class="tab">
                    <ul class="project-list">
                        <li v-for="(item,index) in projectListComplete" :key='index'>
                            <img v-if="item.Status==3 || item.Status==5 || item.Status==6 || item.Status==7" src="../../assets/S3.png" alt="">
                            <div>
                                <p><span>{{item.Name}}</span></p>
                                <p><span>发布时间 :{{item.AddTime}}</span>
                                <span v-if="item.Status==1||item.Status==2">结项时间 <i>{{item.CompleteTime}}</i> </span>
                                </p>
                            </div>
                            <Button type="primary" @click="goDetail(item)"> 管理项目</Button>
                        </li>
                    </ul>
                    <div v-if="projectListComplete.length > 0" style="float:right;padding:30px 0px;">
                        <Page :total="CountComplete" :page-size="PageSize" @on-change="changePageComplete" />
                    </div>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            PageSize: 10,//每页显示数量
            projectListAll:[],//所有项目列表
            Count: 0,
            Page: 1,
            //竞标项目
            projectListBidding:[],
            CountBidding: 0,
            PageBidding: 1,
            //开发中的项目
            projectListDeveloping:[],
            CountDeveloping: 0,
            PageDeveloping: 1,
            //超时项目
            projectListOvertime:[],
            CountOvertime: 0,
            PageOvertime: 1,
            //完成的项目
            projectListComplete:[],
            CountComplete: 0,
            PageComplete: 1,
        }
    },
    mounted(){
        this.getProjectAllList();
        this.getProjectBiddingList();
        this.getProjectDevelopingList();
        this.getProjectOvertimeList();
        this.getProjectCompleteList();
    },
    methods:{
        //获取所有项目列表
        getProjectAllList() {
            this.getProjectList('0', this.Page);
        },
        //获取竞价项目列表
        getProjectBiddingList() {
            this.getProjectList('1', this.PageBidding);
        },
        //获取开发项目列表
        getProjectDevelopingList() {
            this.getProjectList('2', this.PageDeveloping);
        },
        //获取超时项目列表
        getProjectOvertimeList() {
            this.getProjectList('4', this.PageOvertime);
        },
        //获取完成项目列表
        getProjectCompleteList() {
            this.getProjectList('3,5,6,7', this.PageComplete);
        },
        //获取项目列表
        getProjectList(Status, Page) {
            let params = {
                Status: Status,
                page: Page,
                pageSize: this.PageSize,
            }
            this.$post('api/manage.ProjectManage/getProjectList', params).then(res=>{
                if (res.code == 1) {
                    let data = res.data;
                    switch(Status) {
                        case '0': 
                            this.projectListAll = data.data;
                            this.Count = data.all_num;
                            break;
                        case '1':
                            this.projectListBidding = data.data;
                            this.CountBidding = data.all_num;
                            break;
                        case '2': 
                            this.projectListDeveloping = data.data;
                            this.CountDeveloping = data.all_num;
                            break;
                        case '4': 
                            this.projectListOvertime = data.data;
                            this.CountOvertime = data.all_num;
                            break;
                        case '3,5,6,7': 
                            this.projectListComplete = data.data;
                            this.CountComplete = data.all_num;
                            break;
                    }
                 }
            });
        },
        //跳转页面
        changePage(val){
            this.Page=val;
            this.getProjectAllList();
        },
        //跳转竞价中页面
        changePageBidding(val){
            this.PageBidding=val;
            this.getProjectBiddingList();
        },
        //跳转开发中页面
        changePageDeveloping(val){
            this.PageDeveloping=val;
            this.getProjectDevelopingList();
        },
        //跳转已超时页面
        changePageOvertime(val){
            this.PageOvertime=val;
            this.getProjectOvertimeList();
        },
        //跳转已完成页面
        changePageComplete(val){
            this.PageComplete=val;
            this.getProjectCompleteList();
        },
        //列样式控制
        rowClassName (row, index) {
            if ((index%2) === 1) {
                return 'demo-table-info-row';
            } 
            return '';
        },
        //前往项目管理页面
        goDetail(item){
            if (item.Status == 1){
                this.$router.push({path:'BiddingProjectDetail',query:{ID:item.ID}})
            } else if (item.Status == 5) {
                this.$Message.error('该项目竞标超时，已关闭');
            } else {
                this.$router.push({path:'ProjectDetailBidding',query:{ID:item.ID}})
            }
        },
        //前往供应商邀请页面
        goSupplier(item) {
            this.$router.push({path:'SupplierInvite', query:{PID:item.ID}})
        },
        //前往项目发布页面
        publishProject() {
            this.$router.push({path:'PublishProject'});
        }
    }
}
</script>
<style lang="less" scoped>
.box{
    position: relative;
    padding:30px;
    box-sizing: border-box;
    .add-btn{
        position: absolute;
        display: flex;
        align-items: center;
        left:0;
        top:0;
        background-color: #ff4d4d;
        padding:6px 12px;
        border-radius: 5px;
        cursor:pointer;
        img{
            margin-right:5px;
            width: 18px;
            height: 18px;
        }
        span{
            font-size: 16px;
            color: white;
        }
    }
     .tab{
        height: calc(~"100% - 129px");
        margin-top: 60px;
        background-color: #fff;
        box-shadow: 0px 3px 5px #D9DDE3;
    }
    .project-list{
        li{
            overflow: hidden;
            padding:20px;
            border-bottom: 1px solid #E6E9EB;
            position: relative;
            >img{
                position: absolute;
                left:0px;
                top:0px;

            }
            >div{
                float: left;
                padding-left: 30px;
                .private-tag {
                            background-color: #ff4d4d;
                            color: #fff;
                            padding: 5px;
                            border-radius: 5px;
                            margin-right: 5px;
                            font-size: 12px;
                        }
                >p:nth-of-type(1){
                    font-size: 16px;
                    line-height: 40px;
                    display: flex;
                    >span:nth-of-type(2){
                        font-size: 12px;
                        color: #D45D59;
                        border:1px solid #D45D59;
                        border-radius: 5px;
                        padding: 0px 5px;
                        height: 23px;
                        line-height: 23px;
                        margin-top: 15/2px;
                        margin-left: 20px;
                    }
                }
                >p:nth-of-type(2){
                    >span{
                        margin-right:30px;
                        i{
                            color: #FF7F00;
                            font-style: initial;
                        }
                    }

                }
            }
            >button{
                float: right;
                margin-top: 15px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Project/BiddingProject.vue